<!--通讯监测页面查询-->
<template>
  <div style="width: 100%;height: 100%;display: flex;">
    <div class="channelContainer custom-scrollbar">
      <div v-for="(item,i) in channelList" :key="'channel'+i" :class="['channelLi',{'active':item.id == nowChannel.id}]"
        @click="nowChannel = item">
        <p class="channelName">{{item.name}}</p>
        <div class="channelState">
          <p class="stateOff" v-show="item.channelstate == 0">中断</p>
          <p class="stateOn" v-show="item.channelstate == 1">正常</p>
        </div>
      </div>
    </div>
    <div class="deviceContainer custom-scrollbar">
      <div v-for="(item,i) in deviceList" :key='i' class="deviceLi" @click="deviceClick(item)">
        <div class="deviceName flexBetween">
          <p class="betweenLeft1">设备名称：</p>
          <p class="betweenRight1">{{item.name}}</p>
        </div>
        <div class="deviceInfos">
          <div class="flexBetween">
            <p class="betweenLeft">状态
              <!-- <span class="deviceStateOff" v-show="item.devicestate == 0"></span><span class="deviceStateOn" v-show="item.devicestate == 1"></span> -->
              <img v-show="item.devicestate == 1"
                :src="$store.resourcesStore.getters.getResourcesByName('channel/on.png')" alt="" />
              <img v-show="item.devicestate == 0"
                :src="$store.resourcesStore.getters.getResourcesByName('channel/off.png')" alt="" />
            </p>
            <p class="betweenRight">投运状态
              <img v-show="item.run == 1"
                :src="$store.resourcesStore.getters.getResourcesByName('channel/state_on.png')" alt="" />
              <img v-show="item.run == 0"
                :src="$store.resourcesStore.getters.getResourcesByName('channel/state_off.png')" alt="" />
            </p>
          </div>
          <div class="flexBetween">
            <p>设备地址&#x3000;{{item.deviceaddr}}</p>
            <p style="width: calc(45% - 5px);">扩展地址&#x3000;{{item.deviceaddr1}}</p>
          </div>
          <div class="flexBetween">
            <p class="betweenLeft">重复次数&#x3000;{{item.resendcount}}</p>
            <p class="betweenRight">中断次数&#x3000;{{item.breakcount}}</p>
          </div>
          <p>协议&#x3000;{{item.protocol}}</p>
        </div>
      </div>
    </div>
    <deviceVariableListDialog ref="deviceVariableListDialog"></deviceVariableListDialog>
  </div>
</template>

<script>
  import deviceVariableListDialog from './deviceVariableListDialog.vue'
  export default {
    components: {
      deviceVariableListDialog
    },
    props: {},
    data () {
      return {
        nowChannel: undefined,
        nowDevice: undefined,
        nowVariable: undefined,
        channelList: [],
        deviceList: [],
      }
    },
    created () {},
    mounted () {
      debugPage=this
      this.getChannelList()
    },
    destroyed () {},
    computed: {
      nowPage () {
        var list=this.orderListByIndex[this.nowIndex]
        if(list==undefined) {
          return []
        }
        return list
      },
    },
    watch: {
      nowChannel (nv,ov) {
        this.getDeviceList()
      },
    },
    methods: {
      getAllUserList (list) {
        var resultList=[]
        for(var i=0,len=list.length;i<len;i++) {
          var item=list[i]
          if(item.type=='PcmUser') {
            resultList.push(item)
          } else {
            //递归找下级
            resultList.addAll(this.getAllUserList(item.next))
          }
        }
        return resultList
      },
      getChannelList () {
        var pageIndex=1
        var pageSize=100;
        var res=[
          {
            "no": 1,
            "typeDesc": null,
            "channelsort": 1.0,
            "description": "",
            "type": null,
            "parentid": "0",
            "protocol": null,
            "entityName": "Channel",
            "porttext": null,
            "channeltype": 0,
            "databits": null,
            "iptext": null,
            "typetext": null,
            "id": "1",
            "baudrat": null,
            "checktext": null,
            "comport": null,
            "channelstate": 1,
            "sendport": null,
            "node": 0,
            "stopbits": null,
            "createTime": null,
            "protocolfile": null,
            "name": "设备通道一",
            "interval": 0
          },
          {
            "no": 2,
            "typeDesc": null,
            "channelsort": 999.0,
            "description": null,
            "type": null,
            "parentid": null,
            "protocol": null,
            "entityName": "Channel",
            "porttext": null,
            "channeltype": -1,
            "databits": null,
            "iptext": null,
            "typetext": null,
            "id": "2",
            "baudrat": null,
            "checktext": null,
            "comport": null,
            "channelstate": 1,
            "sendport": null,
            "node": 0,
            "stopbits": null,
            "createTime": null,
            "protocolfile": null,
            "name": "设备通道二",
            "interval": 0
          },


          {
            "no": 12,
            "typeDesc": null,
            "channelsort": 1009.0,
            "description": "",
            "type": null,
            "parentid": "0",
            "protocol": null,
            "entityName": "Channel",
            "porttext": null,
            "channeltype": 0,
            "databits": null,
            "iptext": null,
            "typetext": null,
            "id": "12",
            "baudrat": null,
            "checktext": null,
            "comport": null,
            "channelstate": 0.0,
            "sendport": null,
            "node": 0,
            "stopbits": null,
            "createTime": null,
            "protocolfile": null,
            "name": "设备通道三",
            "interval": 100
          }
        ];
        this.channelList=res
        this.nowChannel=res[0]
      },
      getDeviceList () {
        var pageIndex=1
        var pageSize=100;
        var res=[
          {
            "no": 1,
            "devicetag": null,
            "parentarea": 0,
            "channel": 1,
            "description": null,
            "run": 1,
            "modelno": null,
            "infolink": null,
            "deviceaddrex": "202308050002",
            "number": null,
            "deviceaddr": 640,
            "protocol": "CDL645",
            "rundate": null,
            "deviceaddr1": 0,
            "runratetag": null,
            "deviceserialtype": "645",
            "entityName": "Device",
            "parenttag": null,
            "breakcount": 1,
            "devicestate": 1.0,
            "attribute": null,
            "id": "1",
            "appattribute": null,
            "department": null,
            "linkpic": null,
            "group": null,
            "devicesort": 1.0,
            "resendcount": 3,
            "devicetypeid": "a760cb5e9f8547439fbb012e142ef017",
            "devicepkid": null,
            "createTime": null,
            "protocolfile": "protocolDL645_2007_ZF.dll",
            "name": "益大",
            "maintenancecycle": null,
            "madedate": null,
            "madein": null,
            "devicetypename": "645"
          },
          {
            "no": 2,
            "devicetag": null,
            "parentarea": 0,
            "channel": 1,
            "description": null,
            "run": 1,
            "modelno": null,
            "infolink": null,
            "deviceaddrex": "",
            "number": null,
            "deviceaddr": 641,
            "protocol": "",
            "rundate": null,
            "deviceaddr1": 0,
            "runratetag": null,
            "deviceserialtype": "645",
            "entityName": "Device",
            "parenttag": null,
            "breakcount": 1,
            "devicestate": 1.0,
            "attribute": null,
            "id": "2",
            "appattribute": null,
            "department": null,
            "linkpic": null,
            "group": null,
            "devicesort": 2.0,
            "resendcount": 3,
            "devicetypeid": "a760cb5e9f8547439fbb012e142ef017",
            "devicepkid": null,
            "createTime": null,
            "protocolfile": "",
            "name": "奇源",
            "maintenancecycle": null,
            "madedate": null,
            "madein": null,
            "devicetypename": "645"
          },
          {
            "no": 3,
            "devicetag": null,
            "parentarea": 0,
            "channel": 1,
            "description": null,
            "run": 1,
            "modelno": null,
            "infolink": null,
            "deviceaddrex": "",
            "number": null,
            "deviceaddr": 642,
            "protocol": "",
            "rundate": null,
            "deviceaddr1": 0,
            "runratetag": null,
            "deviceserialtype": "645",
            "entityName": "Device",
            "parenttag": null,
            "breakcount": 1,
            "devicestate": 1.0,
            "attribute": null,
            "id": "3",
            "appattribute": null,
            "department": null,
            "linkpic": null,
            "group": null,
            "devicesort": 3.0,
            "resendcount": 3,
            "devicetypeid": "a760cb5e9f8547439fbb012e142ef017",
            "devicepkid": null,
            "createTime": null,
            "protocolfile": "",
            "name": "永兴旺",
            "maintenancecycle": null,
            "madedate": null,
            "madein": null,
            "devicetypename": "645"
          },
          {
            "no": 4,
            "devicetag": null,
            "parentarea": 0,
            "channel": 1,
            "description": null,
            "run": 1,
            "modelno": null,
            "infolink": null,
            "deviceaddrex": "",
            "number": null,
            "deviceaddr": 643,
            "protocol": "",
            "rundate": null,
            "deviceaddr1": 0,
            "runratetag": null,
            "deviceserialtype": "645",
            "entityName": "Device",
            "parenttag": null,
            "breakcount": 1,
            "devicestate": 1.0,
            "attribute": null,
            "id": "4",
            "appattribute": null,
            "department": null,
            "linkpic": null,
            "group": null,
            "devicesort": 4.0,
            "resendcount": 3,
            "devicetypeid": "a760cb5e9f8547439fbb012e142ef017",
            "devicepkid": null,
            "createTime": null,
            "protocolfile": "",
            "name": "金盈毛绒工艺",
            "maintenancecycle": null,
            "madedate": null,
            "madein": null,
            "devicetypename": "645"
          },
          {
            "no": 5,
            "devicetag": null,
            "parentarea": 0,
            "channel": 1,
            "description": null,
            "run": 1,
            "modelno": null,
            "infolink": null,
            "deviceaddrex": "",
            "number": null,
            "deviceaddr": 644,
            "protocol": "",
            "rundate": null,
            "deviceaddr1": 0,
            "runratetag": null,
            "deviceserialtype": "645",
            "entityName": "Device",
            "parenttag": null,
            "breakcount": 1,
            "devicestate": 1.0,
            "attribute": null,
            "id": "5",
            "appattribute": null,
            "department": null,
            "linkpic": null,
            "group": null,
            "devicesort": 5.0,
            "resendcount": 3,
            "devicetypeid": "a760cb5e9f8547439fbb012e142ef017",
            "devicepkid": null,
            "createTime": null,
            "protocolfile": "",
            "name": "利兴强箱变",
            "maintenancecycle": null,
            "madedate": null,
            "madein": null,
            "devicetypename": "645"
          },
          {
            "no": 6,
            "devicetag": null,
            "parentarea": 0,
            "channel": 1,
            "description": null,
            "run": 1,
            "modelno": null,
            "infolink": null,
            "deviceaddrex": "",
            "number": null,
            "deviceaddr": 929,
            "protocol": "",
            "rundate": null,
            "deviceaddr1": 0,
            "runratetag": null,
            "deviceserialtype": "产品电表模板",
            "entityName": "Device",
            "parenttag": null,
            "breakcount": 1,
            "devicestate": 1.0,
            "attribute": null,
            "id": "6",
            "appattribute": null,
            "department": null,
            "linkpic": null,
            "group": null,
            "devicesort": 6.0,
            "resendcount": 3,
            "devicetypeid": "ee159a271e6141b4b77797468f11cb3e",
            "devicepkid": null,
            "createTime": null,
            "protocolfile": "",
            "name": "永宁机电1数显表",
            "maintenancecycle": null,
            "madedate": null,
            "madein": null,
            "devicetypename": "产品"
          },
          {
            "no": 7,
            "devicetag": null,
            "parentarea": 0,
            "channel": 1,
            "description": null,
            "run": 1,
            "modelno": null,
            "infolink": null,
            "deviceaddrex": "",
            "number": null,
            "deviceaddr": 930,
            "protocol": "",
            "rundate": null,
            "deviceaddr1": 0,
            "runratetag": null,
            "deviceserialtype": "产品电表模板",
            "entityName": "Device",
            "parenttag": null,
            "breakcount": 1,
            "devicestate": 1.0,
            "attribute": null,
            "id": "7",
            "appattribute": null,
            "department": null,
            "linkpic": null,
            "group": null,
            "devicesort": 7.0,
            "resendcount": 3,
            "devicetypeid": "ee159a271e6141b4b77797468f11cb3e",
            "devicepkid": null,
            "createTime": null,
            "protocolfile": "",
            "name": "永宁机电2数显表",
            "maintenancecycle": null,
            "madedate": null,
            "madein": null,
            "devicetypename": "产品"
          },
          {
            "no": 8,
            "devicetag": null,
            "parentarea": 0,
            "channel": 1,
            "description": null,
            "run": 1,
            "modelno": null,
            "infolink": null,
            "deviceaddrex": "",
            "number": null,
            "deviceaddr": 931,
            "protocol": "",
            "rundate": null,
            "deviceaddr1": 0,
            "runratetag": null,
            "deviceserialtype": "产品电表模板",
            "entityName": "Device",
            "parenttag": null,
            "breakcount": 1,
            "devicestate": 1.0,
            "attribute": null,
            "id": "8",
            "appattribute": null,
            "department": null,
            "linkpic": null,
            "group": null,
            "devicesort": 8.0,
            "resendcount": 3,
            "devicetypeid": "ee159a271e6141b4b77797468f11cb3e",
            "devicepkid": null,
            "createTime": null,
            "protocolfile": "",
            "name": "永宁机电3数显表",
            "maintenancecycle": null,
            "madedate": null,
            "madein": null,
            "devicetypename": "产品"
          },
          {
            "no": 9,
            "devicetag": null,
            "parentarea": 0,
            "channel": 1,
            "description": null,
            "run": 1,
            "modelno": null,
            "infolink": null,
            "deviceaddrex": "",
            "number": null,
            "deviceaddr": 932,
            "protocol": "",
            "rundate": null,
            "deviceaddr1": 0,
            "runratetag": null,
            "deviceserialtype": "产品电表模板",
            "entityName": "Device",
            "parenttag": null,
            "breakcount": 1,
            "devicestate": 1.0,
            "attribute": null,
            "id": "9",
            "appattribute": null,
            "department": null,
            "linkpic": null,
            "group": null,
            "devicesort": 9.0,
            "resendcount": 3,
            "devicetypeid": "ee159a271e6141b4b77797468f11cb3e",
            "devicepkid": null,
            "createTime": null,
            "protocolfile": "",
            "name": "永宁机电5数显表",
            "maintenancecycle": null,
            "madedate": null,
            "madein": null,
            "devicetypename": "产品"
          },
          {
            "no": 10,
            "devicetag": null,
            "parentarea": 0,
            "channel": 1,
            "description": null,
            "run": 1,
            "modelno": null,
            "infolink": null,
            "deviceaddrex": "",
            "number": null,
            "deviceaddr": 933,
            "protocol": "",
            "rundate": null,
            "deviceaddr1": 0,
            "runratetag": null,
            "deviceserialtype": "产品电表模板",
            "entityName": "Device",
            "parenttag": null,
            "breakcount": 1,
            "devicestate": 1.0,
            "attribute": null,
            "id": "10",
            "appattribute": null,
            "department": null,
            "linkpic": null,
            "group": null,
            "devicesort": 10.0,
            "resendcount": 3,
            "devicetypeid": "ee159a271e6141b4b77797468f11cb3e",
            "devicepkid": null,
            "createTime": null,
            "protocolfile": "",
            "name": "永宁机电补偿回路数显表",
            "maintenancecycle": null,
            "madedate": null,
            "madein": null,
            "devicetypename": "产品"
          },
          {
            "no": 11,
            "devicetag": "23",
            "parentarea": 0,
            "channel": 1,
            "description": null,
            "run": 1,
            "modelno": null,
            "infolink": null,
            "deviceaddrex": "",
            "number": null,
            "deviceaddr": 934,
            "protocol": "",
            "rundate": null,
            "deviceaddr1": 0,
            "runratetag": null,
            "deviceserialtype": "产品电表模板",
            "entityName": "Device",
            "parenttag": "292815260856321",
            "breakcount": 1,
            "devicestate": 1.0,
            "attribute": null,
            "id": "11",
            "appattribute": null,
            "department": null,
            "linkpic": null,
            "group": null,
            "devicesort": 11.0,
            "resendcount": 3,
            "devicetypeid": "ee159a271e6141b4b77797468f11cb3e",
            "devicepkid": null,
            "createTime": null,
            "protocolfile": "",
            "name": "设备机电总进线数显表",
            "maintenancecycle": null,
            "madedate": null,
            "madein": null,
            "devicetypename": "产品"
          },
          {
            "no": 12,
            "devicetag": null,
            "parentarea": 0,
            "channel": 1,
            "description": null,
            "run": 1,
            "modelno": null,
            "infolink": null,
            "deviceaddrex": "",
            "number": null,
            "deviceaddr": 935,
            "protocol": "",
            "rundate": null,
            "deviceaddr1": 0,
            "runratetag": null,
            "deviceserialtype": "产品电表模板",
            "entityName": "Device",
            "parenttag": null,
            "breakcount": 1,
            "devicestate": 1.0,
            "attribute": null,
            "id": "12",
            "appattribute": null,
            "department": null,
            "linkpic": null,
            "group": null,
            "devicesort": 12.0,
            "resendcount": 3,
            "devicetypeid": "ee159a271e6141b4b77797468f11cb3e",
            "devicepkid": null,
            "createTime": null,
            "protocolfile": "",
            "name": "永宁机电4数显表",
            "maintenancecycle": null,
            "madedate": null,
            "madein": null,
            "devicetypename": "产品"
          },
          {
            "no": 13,
            "devicetag": null,
            "parentarea": 0,
            "channel": 1,
            "description": null,
            "run": 1,
            "modelno": null,
            "infolink": null,
            "deviceaddrex": "",
            "number": null,
            "deviceaddr": 1211,
            "protocol": "",
            "rundate": null,
            "deviceaddr1": 0,
            "runratetag": null,
            "deviceserialtype": "产品电表模板",
            "entityName": "Device",
            "parenttag": null,
            "breakcount": 1,
            "devicestate": 1.0,
            "attribute": null,
            "id": "13",
            "appattribute": null,
            "department": null,
            "linkpic": null,
            "group": null,
            "devicesort": 13.0,
            "resendcount": 3,
            "devicetypeid": "ee159a271e6141b4b77797468f11cb3e",
            "devicepkid": null,
            "createTime": null,
            "protocolfile": "",
            "name": "水元一4011电线1211",
            "maintenancecycle": null,
            "madedate": null,
            "madein": null,
            "devicetypename": "产品"
          },
          {
            "no": 14,
            "devicetag": null,
            "parentarea": 0,
            "channel": 1,
            "description": null,
            "run": 1,
            "modelno": null,
            "infolink": null,
            "deviceaddrex": "",
            "number": null,
            "deviceaddr": 1213,
            "protocol": "",
            "rundate": null,
            "deviceaddr1": 0,
            "runratetag": null,
            "deviceserialtype": "产品电表模板",
            "entityName": "Device",
            "parenttag": null,
            "breakcount": 1,
            "devicestate": 1.0,
            "attribute": null,
            "id": "14",
            "appattribute": null,
            "department": null,
            "linkpic": null,
            "group": null,
            "devicesort": 14.0,
            "resendcount": 3,
            "devicetypeid": "ee159a271e6141b4b77797468f11cb3e",
            "devicepkid": null,
            "createTime": null,
            "protocolfile": "",
            "name": "水元一4031厂房",
            "maintenancecycle": null,
            "madedate": null,
            "madein": null,
            "devicetypename": "产品"
          },
          {
            "no": 15,
            "devicetag": null,
            "parentarea": 0,
            "channel": 1,
            "description": null,
            "run": 1,
            "modelno": null,
            "infolink": null,
            "deviceaddrex": "",
            "number": null,
            "deviceaddr": 1214,
            "protocol": "",
            "rundate": null,
            "deviceaddr1": 0,
            "runratetag": null,
            "deviceserialtype": "产品电表模板",
            "entityName": "Device",
            "parenttag": null,
            "breakcount": 1,
            "devicestate": 1.0,
            "attribute": null,
            "id": "15",
            "appattribute": null,
            "department": null,
            "linkpic": null,
            "group": null,
            "devicesort": 15.0,
            "resendcount": 3,
            "devicetypeid": "ee159a271e6141b4b77797468f11cb3e",
            "devicepkid": null,
            "createTime": null,
            "protocolfile": "",
            "name": "水元一4032厂房",
            "maintenancecycle": null,
            "madedate": null,
            "madein": null,
            "devicetypename": "产品"
          },
          {
            "no": 16,
            "devicetag": "11",
            "parentarea": 0,
            "channel": 1,
            "description": null,
            "run": 1,
            "modelno": null,
            "infolink": null,
            "deviceaddrex": "",
            "number": null,
            "deviceaddr": 1215,
            "protocol": "",
            "rundate": null,
            "deviceaddr1": 0,
            "runratetag": null,
            "deviceserialtype": "产品电表模板",
            "entityName": "Device",
            "parenttag": "292815260856321",
            "breakcount": 1,
            "devicestate": 1.0,
            "attribute": null,
            "id": "16",
            "appattribute": null,
            "department": null,
            "linkpic": null,
            "group": null,
            "devicesort": 16.0,
            "resendcount": 3,
            "devicetypeid": "ee159a271e6141b4b77797468f11cb3e",
            "devicepkid": null,
            "createTime": null,
            "protocolfile": "",
            "name": "气元一4033厂房",
            "maintenancecycle": null,
            "madedate": null,
            "madein": null,
            "devicetypename": "产品"
          },
          {
            "no": 17,
            "devicetag": null,
            "parentarea": 0,
            "channel": 1,
            "description": null,
            "run": 1,
            "modelno": null,
            "infolink": null,
            "deviceaddrex": "",
            "number": null,
            "deviceaddr": 1216,
            "protocol": "",
            "rundate": null,
            "deviceaddr1": 0,
            "runratetag": null,
            "deviceserialtype": "产品电表模板",
            "entityName": "Device",
            "parenttag": null,
            "breakcount": 1,
            "devicestate": 1.0,
            "attribute": null,
            "id": "17",
            "appattribute": null,
            "department": null,
            "linkpic": null,
            "group": null,
            "devicesort": 17.0,
            "resendcount": 3,
            "devicetypeid": "ee159a271e6141b4b77797468f11cb3e",
            "devicepkid": null,
            "createTime": null,
            "protocolfile": "",
            "name": "气元一4034厂房",
            "maintenancecycle": null,
            "madedate": null,
            "madein": null,
            "devicetypename": "产品"
          },
          {
            "no": 18,
            "devicetag": null,
            "parentarea": 0,
            "channel": 1,
            "description": null,
            "run": 1,
            "modelno": null,
            "infolink": null,
            "deviceaddrex": "",
            "number": null,
            "deviceaddr": 1217,
            "protocol": "",
            "rundate": null,
            "deviceaddr1": 0,
            "runratetag": null,
            "deviceserialtype": "产品电表模板",
            "entityName": "Device",
            "parenttag": null,
            "breakcount": 1,
            "devicestate": 1.0,
            "attribute": null,
            "id": "18",
            "appattribute": null,
            "department": null,
            "linkpic": null,
            "group": null,
            "devicesort": 18.0,
            "resendcount": 3,
            "devicetypeid": "ee159a271e6141b4b77797468f11cb3e",
            "devicepkid": null,
            "createTime": null,
            "protocolfile": "",
            "name": "气元一4035厂房",
            "maintenancecycle": null,
            "madedate": null,
            "madein": null,
            "devicetypename": "产品"
          }
        ];
        this.deviceList=res
        this.nowDevice=res[0]
      },
      deviceClick (device) {
        this.nowDevice=device
        this.$refs.deviceVariableListDialog.open('['+device.name+'] 变量实时值列表',device)
      },
    }
  }
</script>

<style scoped lang="scss">
  .channelContainer {
    height: 100%;
    width: 240px;
    background-color: #FFFFFF;
    /* margin-right: 10px; */
    border-right: 1px solid #E6E6E6;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    justify-content: center;
  }

  .channelLi {
    width: 174px;
    /* height: 110px; */
    /* background-color: #E5E5E5; */
    display: flex;
    border: 1px solid #E6E6E6;
    margin-top: 20px;
    border-radius: 5px;
    padding: 21px 12px;
    cursor: pointer;

    &:hover {
      border-color: #3E9AF8;
    }

    &.active {
      background-color: #DBEDFF;
      border-color: #3E9AF8;
    }
  }

  .channelName {
    font-size: .15rem;
    /* line-height: 50px; */
    text-align: center;
    margin-right: 42px;
    width: 1rem;
    color: #1a1a1a
  }

  .channelState {
    display: flex;
    align-items: center;
    /* justify-content: center; */
  }

  /* .channelState>P{
		margin-top: 20px;
	} */

  .stateOn {
    color: #0FA770;
    line-height: 24px;
    /* padding: 0 10px; */
    width: 44px;
    height: 24px;
    text-align: center;
    border-radius: 4px;
    background-color: #abedd5;
  }

  .stateOff {
    color: #DC593C;
    line-height: 24px;
    /* padding: 0 10px; */
    width: 44px;
    height: 24px;
    text-align: center;
    border-radius: 4px;
    background-color: #f9c6bb;
  }

  .deviceContainer {
    width: calc(100% - 200px);
    background-color: #FFFFFF;
    padding: 10px 0;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
  }

  .deviceLi {
    width: calc(20% - 22px);
    margin: 10px;
    // border: solid 1px #E4E4E4;
    border-radius: 5px;
    overflow: hidden;
    box-shadow: 0px 4px 8px 0px #e8eff5;
  }

  .deviceName {
    background-color: #dbedff;
    height: 42px;
    padding: 0 10px;
    justify-content: flex-start;

  }

  .deviceName>p {
    font-size: .14rem;
    color: #3E9AF8;
  }

  .betweenLeft {
    width: calc(55% - 5px);
    display: flex;
    align-items: center;

    img {
      margin-left: 5px;
      width: 0.16rem;
      height: 0.16rem;
    }
  }

  .betweenRight {
    width: calc(45% - 5px);
    display: flex;
    align-items: center;
  }

  .betweenRight>img {
    width: 14px;
    height: 14px;
    margin-left: 10px;
  }

  .deviceInfos {
    padding: 0 10px;
  }

  .deviceInfos p {
    line-height: 30px;
    color: #616161;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .deviceStateOff {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: #F56161;
    margin-left: 10px;
  }

  .deviceStateOn {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: green;
    margin-left: 10px;
  }

  @media screen and (max-width:1600px) {
    .deviceLi {
      width: calc(25% - 22px);
    }
  }
</style>